module.exports = "/packs/media/images/module-wealth-c9be2cb22957eff37f3714986e74e635.png";